import { Route } from '@angular/router';
import { IGuardData } from '@portal/shared/auth/authorization';
export interface IPortalRoute extends Route {
  data: {
    [key: string]: any;
    breadcrumbs?: {
      label: string;
      path?: string;
    };
    permission?: IGuardData;
  };
}
